export const environment = {
  production: true,
  API_URL: 'https://api.techfino.in/api/v1/',

  RAZOR_PAY_KEY: 'rzp_live_FOec3YklxlTl2O',
  RAZOR_PAY_KEY_ENACH: 'rzp_live_rhMiG8HOJ2UFw1',

  COMPANY_NAME: 'Techfino Capital Private Limited',

  pingInterval: 5,
  PAYMENT_PROCESSING_FEE_DESCRIPTION: 'Payment',
  PAYMENT_EMI_DESCRIPTION: 'Pay EMI',
  AUTH_PAYMENT_DESCRIPTION: 'E-Nach auth transaction',
  CUSTOMER_CLIENT_PATH: 'http://192.168.0.228:4201/customer/#',
  TERMS_AND_CONDITIONS_PATH: 'https://s3.ap-south-1.amazonaws.com/techfino-prod/TnC/',
  WELCOME_LETTER_PATH: 'https://s3.ap-south-1.amazonaws.com/techfino-prod/Welcome_schedule/',
  DIGIO_ENVIRONMENT: 'production',
  COMPANY_LOGO: 'https://s3.amazonaws.com/techfino.static/logoTechFino.png',
  GET_PUBLIC_IP_URL: 'https://api.ipify.org?format=json'
};
